<!--  根据推荐位ID，查产品列表-->
<template>
  <div>
    <van-loading v-show="showLoad" type="spinner" color="#ff6c02" />
    <div v-if="isCourseCard === 1" class="hotCourse" >
      <div v-for="(item, keys) in courseInfoList" :key="keys">
        <CombinationCard v-if="item.setType === 1" :key="keys" :item="item" />
        <HotCourseCard v-else :key="keys" :item="item" />
      </div>
    </div>
    <div v-if="isCourseCard === 2" class="nullCourse">
      <EmptyData :emptyName="'noProductList'" />
    </div>
  </div>
</template>

<script>
import { resetProductData, resetCoursePackage } from '@/utils/tools';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { reqMajorAd, reqProducts } from '@/api/home';
import { reqCombinationlist } from '@/api/combination';
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';

export default {
  components: {
    EmptyData,
    HotCourseCard,
    CombinationCard,
  },
  data() {
    return {
      courseInfoList: [],
      isCourseCard: 0,
      showLoad: false,
    };
  },
  props: {
    recomendId: {
      type: String,
      default: '',
    },
  },
  computed: {},
  watch: {
    recomendId: {
      deep: true,
      immediate: true,
      handler(id) {
        console.log(id,'recomendId')
        this.showLoad=true;
        this.courseInfoList=[];
        this.isCourseCard=0;
        this.getMajorCourse(id);
      },
    },
  },
  methods: {
    // 专业课广告位课程列表查询
    async getMajorCourse(id) {
      if (!id) return;
      const { code, data } = await reqMajorAd(id);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      } else {
        this.isCourseCard = 2;
        this.showLoad = false;
      }
    },
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};
      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = resetProductData(res?.data || [], 2);
        const resPackage = resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && allCourse.push(findRes);
        });
        this.courseInfoList = allCourse;
        this.showLoad = false;
        this.isCourseCard = allCourse.length ? 1 : 2;
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
 ::v-deep .emptyIndent {
    height: auto;
  }
  ::v-deep.van-loading{
    text-align: center;
  }
</style>
